import { gql } from '@apollo/client';

export const CURRENT_USER_ACTIVITY_ROLES = gql`
  query currentUserActivityRoles {
    currentUserActivityRoles {
      activityId
      role
    }
  }
`;
